import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../stores/useAuthStore";
import { CheckoutLayout } from "./CheckoutLayout";
import { Clock } from "lucide-react";

const getCookie = (name: string) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};

export function CheckoutPending() {
  const navigate = useNavigate();
  const { tableId, tenant } = useAuthStore();
  const entryToken = localStorage.getItem('kiero_entry_token')
    || getCookie('kiero_entry_token')
    || sessionStorage.getItem('entry_token');
  const isKiero = !!entryToken || tenant?.partner_branding === 'KIERO';

  return (
    <CheckoutLayout
      title="Pago Pendiente"
      icon={<Clock className="w-12 h-12" />}
      message="Pago en Proceso"
      description="Tu pago está siendo procesado. Por favor, espera un momento..."
      iconBgColor="bg-yellow-100 dark:bg-yellow-900/20"
      iconTextColor="text-yellow-600 dark:text-yellow-400"
      actionButton={
        <button
          onClick={() => {
            if (entryToken) {
              navigate(`/simple-dashboard/${entryToken}`);
            } else {
              navigate(`/dashboard/${tableId || ""}`);
            }
          }}
          className="w-full bg-yellow-500 hover:bg-yellow-600 text-white py-3 rounded-lg font-medium transition-colors"
        >
          {isKiero ? "Ver Mis Pedidos" : "Volver al Inicio"}
        </button>
      }
    />
  );
}